import Axios, { Response } from '../utils/Axios';

export type RangeSettleType = {
  store_id_list: number[];
  start_date: string;
  end_date: string;
  start_rn: number | null;
  end_rn: number | undefined;
};
export type PeriodSettle = {
  sales: SalesListType[];
  total: TotalListType;
};
export type TotalListType = {
  avg_cancel_sales: number;
  avg_com_discount_sales: number;
  avg_sales: number;
  avg_store_discount_sales: number;
  cancel_sales_count: number;
  com_discount_sales_count: number;
  sales_count: number;
  store_discount_sales_count: number;
  sum_cancel_salse: number;
  sum_com_discount_amount: number;
  sum_sales: number;
  sum_store_discount_amount: number;
  total_sales_count: number;
  sum_delivery_tip: number;
  sum_room_tip:number;
  sum_cancel_room_tip:number;
};
export type SalesListType = {
  com_discount_amount: number;
  detail: string;
  discount_amount: number;
  order_id: string;
  order_status: number;
  ordered_at: string;
  rn: number;
  store_discount_amount: number;
  store_name: string;
  room_tip:number;
  total_amount_incl: number;
};
// 정산
export type SettlementType = {
  store_id: number;
  start_date: string;
  end_date: string;
};
export type SettlementListType = {
  store_id: number;
  scheduled_date: string;
  settlement_start_date: string;
  settlement_end_date: string;
  deposit_status: string;
  transfer_status: number;
  order_amount: number;
  store_discount_amt: number;
  com_discount_amt: number;
  delivery_price: number;
  final_payment_amt: number;
  payment_fee: number;
  room_tip: number;
  relay_fee: number;
  vat: number;
  total_deductions: number;
  scheduled_settlement_amt: number;
};

// =============================
export type DailySettle = {
  sales: any[];
  total: TotalListType;
};
export type SalesData = {
  total_rn: number;
  sales_date: string;
  net_sales: number;
  net_sales_cnt: number;
  total_refund_amt: number;
  total_refund_cnt: number;
  total_amount: number;
  total_cnt: number;
};

export type DailyPayment = {
  rn: 1;
  payment_at: string;
  tran_type: string;
  pay_type: string;
  amount: number;
  vat_amount: number;
  net_amount: number;
  approval_no: string;
  org_approval_no: string;
  cancel_fg: number;
  cash_type: string;
  order_id: string;
  order_seq: number;
};

export type GetSalesAnalysisByCateType = {
  total_rn: number;
  items: CategorySaleType[];
};

export type GetSalesAnalysisByPrdType = {
  total_rn: number;
  items: ProductSaleType[];
};

export type CategorySaleType = {
  rn: number;
  category_id: number;
  name: string;
  total_product_quantity: string;
  total_amount: string;
};

export type ProductSaleType = {
  rn: number;
  product_id: number;
  name: string;
  product_price: number;
  total_product_quantity: string;
  total_amount: string;
};

export type ProductHourSaleType = {
  rn: number;
  ordered_hour: string;
  product_rn: number;
  product_id: number;
  name: string;
  total_amount: number;
  total_product_quantity: number;
};

export type HourSaleAnalysisType = {
  ordered_hour: string;
  order_total_product_quantity: number;
  order_total_amount: number;
};

const SettlementController = {
  // 기간별매출
  getDateRangeSettle: async (oParams: RangeSettleType) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/settlement/getDateRangeSettle';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[기간별매출 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 기간별매출 상세 주문 내역
  getOrderByOrderId: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/order/getOrderByOrderId';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[기간별매출 상세 주문 내역]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 정산내역
  getSettlement: async (oParams: SettlementType) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/settlement/getSettlement';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[정산내역 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getSettlementDetail: async (oParams: SettlementType) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/settlement/getSettlementDetail';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[정산상세내역 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  getCalendarSettle: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/settlement/getCalendarSettle';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[달력매출 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getDailySettle: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/settlement/getDailySettle';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로그인 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  getCategorySale: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/settlement/getSalesAnalysisByCate';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로그인 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  getSalesAnalysisByTime: async (oParams: {
    start_date: string;
    end_date: string;
    start_time: number;
    end_time: number;
  }): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/settlement/getSalesAnalysisByTime';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로그인 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  getProductSale: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/settlement/getSalesAnalysisByPrd';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로그인 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  getTranType: (tranType: string) => {
    if (tranType === 'APPROVAL') {
      return '승인';
    } else if (tranType === 'CANCEL') {
      return '취소';
    } else {
      return tranType;
    }
  },

  getPayType: (payType: string, cash_type?: string) => {
    if (payType === 'CARD') {
      return '카드';
    } else if (payType === 'CASH') {
      if (cash_type === undefined || cash_type === null) {
        return '현금';
      } else if (cash_type === '01') {
        return '현금영수증(개인)';
      } else if (cash_type === '02') {
        return '지출증빙(사업자)';
      } else if (cash_type === '03') {
        return '자진발급';
      } else if (cash_type === '04') {
        return '현금';
      } else {
        return payType;
      }
    } else if (payType === 'EASY') {
      return '간편결제';
    } else if (payType === 'DISCOUNT') {
      return '할인';
    } else {
      return payType;
    }
  },

  getPeriodSettle: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/settlement/getDateRangeSettle';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로그인 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};

export default SettlementController;
